import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { AnotacaoSolicitacao } from '@/types/_'


const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async getSurgeryAnnotations(surgerySolicitationId: string) {
    const request = await api.get(`solicitacao/${surgerySolicitationId}/anotacoes`)
    return factory.build<any>(request)
  },

  async storeSurgeryAnnotation(annotationData: AnotacaoSolicitacao) {
    const request = await api.post('solicitacao/anotacoes', annotationData)
    return factory.build<any>(request)
  },

  async storeSurgeryAnnotationAttachment(formData: FormData) {
    const header: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = await api.upload('files', formData, header)
    return factory.build(request)
  },

  async deleteSurgeryAnnotation(surgerySolicitationId: string, annotationId: string) {
    const request = await api.delete(`/solicitacao/${surgerySolicitationId}/anotacoes/${annotationId}`)
    return factory.build(request)
  },
}
